import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import 'babel-polyfill';

import routeMap from './config/routeMap';

import LoadableHoc from './components/LoadingComponent/LoadableHoc';


import style from './components/App/App.module.scss';

const Home = LoadableHoc({ loader: () => import('./views/Start/Home')});
const Recycling = LoadableHoc({ loader: () => import('./views/Recycling/Recycling')});
const RecyclingPage2 = LoadableHoc({ loader: () => import('./views/Recycling/RecyclingPage2')});
const RecyclingPage3 = LoadableHoc({ loader: () => import('./views/Recycling/RecyclingPage3')});
const RecyclingPage4 = LoadableHoc({ loader: () => import('./views/Recycling/RecyclingPage4')});
const Programming = LoadableHoc({ loader: () => import('./views/Programming/Programming')});
const ProgrammingPage2 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage2')});
const ProgrammingPage3 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage3')});
const ProgrammingPage4 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage4')});
const ProgrammingPage5 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage5')});
const ProgrammingPage6 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage6')});
const ProgrammingPage7 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage7')});
const ProgrammingPage8 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage8')});
const ProgrammingPage9 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage9')});
const ProgrammingPage10 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage10')});
const ProgrammingPage11 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage11')});
const ProgrammingPage12 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage12')});
const ProgrammingPage13 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage13')});
const ProgrammingPage14 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage14')});
const ProgrammingPage15 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage15')});
const ProgrammingPage16 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage16')});
const ProgrammingPage17 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage17')});
const ProgrammingPage18 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage18')});
const ProgrammingPage19 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage19')});
const ProgrammingPage20 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage20')});
const ProgrammingPage21 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage21')});
const ProgrammingPage22 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage22')});
const ProgrammingPage23 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage23')});
const ProgrammingPage24 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage24')});
const ProgrammingPage25 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage25')});
const ProgrammingPage26 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage26')});
const ProgrammingPage27 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage27')});
const ProgrammingPage28 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage28')});
const ProgrammingPage29 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage29')});
const ProgrammingPage30 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage30')});
const ProgrammingPage31 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage31')});
const ProgrammingPage32 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage32')});
const ProgrammingPage33 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage33')});
const ProgrammingPage34 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage34')});
const ProgrammingPage35 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage35')});
const ProgrammingPage36 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage36')});
const ProgrammingPage37 = LoadableHoc({ loader: () => import('./views/Programming/ProgrammingPage37')});

class App extends Component {

  render() {
    return (
      <div className={style.appContainer}>
        <BrowserRouter>
          <Switch>
            <Route path={routeMap.home} exact component={Home} />
            <Route path={routeMap.recycling} exact component={Recycling} />
            <Route path={routeMap.recycling_2_trash} exact component={RecyclingPage2} />
            <Route path={routeMap.recycling_3_pet} exact component={RecyclingPage3} />
            <Route path={routeMap.recycling_4_secondlife} exact component={RecyclingPage4} />
            <Route path={routeMap.programming} exact component={Programming} />
            <Route path={routeMap.programming_2_cleanup} exact component={ProgrammingPage2} />
            <Route path={routeMap.programming_3_whats_that} exact component={ProgrammingPage3} />
            <Route path={routeMap.programming_4_code_syntax} exact component={ProgrammingPage4} />
            <Route path={routeMap.programming_5_robot_control} exact component={ProgrammingPage5} />
            <Route path={routeMap.programming_6_first_task} exact component={ProgrammingPage6} />
            <Route path={routeMap.programming_7_first_quiz} exact component={ProgrammingPage7} />
            <Route path={routeMap.programming_8_second_task} exact component={ProgrammingPage8} />
            <Route path={routeMap.programming_9_third_task} exact component={ProgrammingPage9} />
            <Route path={routeMap.programming_10_second_skribot} exact component={ProgrammingPage10} />
            <Route path={routeMap.programming_11_pet_quiz} exact component={ProgrammingPage11} />
            <Route path={routeMap.programming_12_programming_logic} exact component={ProgrammingPage12} />
            <Route path={routeMap.programming_13_true_false_test} exact component={ProgrammingPage13} />
            <Route path={routeMap.programming_14_parameters} exact component={ProgrammingPage14} />
            <Route path={routeMap.programming_15_decission} exact component={ProgrammingPage15} />
            <Route path={routeMap.programming_16_else_statements} exact component={ProgrammingPage16} />
            <Route path={routeMap.programming_17_pet_bottle_sign_quiz} exact component={ProgrammingPage17} />
            <Route path={routeMap.programming_18_what_if} exact component={ProgrammingPage18} />
            <Route path={routeMap.programming_19_more_conditions} exact component={ProgrammingPage19} />
            <Route path={routeMap.programming_20_segregation} exact component={ProgrammingPage20} />
            <Route path={routeMap.programming_21_conditions} exact component={ProgrammingPage21} />
            <Route path={routeMap.programming_22_yellow_bin_quiz} exact component={ProgrammingPage22} />
            <Route path={routeMap.programming_23_object} exact component={ProgrammingPage23} />
            <Route path={routeMap.programming_24_segregation_process} exact component={ProgrammingPage24} />
            <Route path={routeMap.programming_25_skribot_on_track} exact component={ProgrammingPage25} />
            <Route path={routeMap.programming_26_skribot_on_track_task} exact component={ProgrammingPage26} />
            <Route path={routeMap.programming_27_skribot_on_track_second_task} exact component={ProgrammingPage27} />
            <Route path={routeMap.programming_28_and_or} exact component={ProgrammingPage28} />
            <Route path={routeMap.programming_29_true_false_second_quiz} exact component={ProgrammingPage29} />
            <Route path={routeMap.programming_30_skribot_on_track_third_task} exact component={ProgrammingPage30} />
            <Route path={routeMap.programming_31_second_skribot_on_track} exact component={ProgrammingPage31} />
            <Route path={routeMap.programming_32_while} exact component={ProgrammingPage32} />
            <Route path={routeMap.programming_33_skribot_story_part_one} exact component={ProgrammingPage33} />
            <Route path={routeMap.programming_34_skribot_story_part_two} exact component={ProgrammingPage34} />
            <Route path={routeMap.programming_35_skribot_story_part_three} exact component={ProgrammingPage35} />
            <Route path={routeMap.programming_36_skribot_story_part_four} exact component={ProgrammingPage36} />
            <Route path={routeMap.programming_37_finish} exact component={ProgrammingPage37} />
            <Route component={Home} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js